import { render, staticRenderFns } from "./EditImage.vue?vue&type=template&id=8845336a&scoped=true&"
import script from "./EditImage.vue?vue&type=script&lang=js&"
export * from "./EditImage.vue?vue&type=script&lang=js&"
import style0 from "./EditImage.vue?vue&type=style&index=0&id=8845336a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8845336a",
  null
  
)

export default component.exports